import clsx from 'clsx';

function StreakStats({ currentStreak, personalRecord, className = '' }) {
    const headingClasses = 'heading-anton tw-text-[1.25em]';

    return (
        <div className={className}>
            <div className="tw-flex tw-flex-col tw-gap-4 tw-w-full">
                <div className="tw-flex tw-items-center tw-w-full">
                    <span className={clsx(headingClasses, 'tw-text-left')}>Current Streak:</span>
                    <div className="tw-flex-1"></div>
                    <div className="tw-flex tw-items-center tw-gap-2">
                        <span className={clsx(headingClasses, 'tw-whitespace-nowrap')}>{currentStreak} DAYS</span>
                        <span className="tw-text-[1.25em]">🔥</span>
                    </div>
                </div>
                <div className="tw-flex tw-items-center tw-w-full">
                    <span className={clsx(headingClasses, 'tw-text-left')}>Personal Record:</span>
                    <div className="tw-flex-1"></div>
                    <div className="tw-flex tw-items-center tw-gap-2">
                        <span className={clsx(headingClasses, 'tw-whitespace-nowrap')}>{personalRecord} DAYS</span>
                        <span className="tw-text-[1.25em]">🏆</span>
                    </div>
                </div>
            </div>
        </div>
    );
}

export default StreakStats;
